import { all, fork } from 'redux-saga/effects';

import GroupSetsSagas from './groupSets.sagas';
import CostTablesSagas from './costTables.sagas';

export default function* rootSaga() {
  yield all([
    ...GroupSetsSagas.map(saga => fork(saga)),
    ...CostTablesSagas.map(saga => fork(saga)),
  ]);
}
